import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { StepperStep } from './StepperStep';
import type { TStepperSidePaneProps } from './types';

export const StepperSidePane = ({ title, steps, styles, active }: TStepperSidePaneProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={styles.sidePane}>
      {title && (
        <Typography variant="h6" sx={styles.sidePaneTitle}>
          {t(title)}
        </Typography>
      )}

      {steps.map((step, index) => (
        <StepperStep
          key={step.id}
          title={t(step.title)}
          index={`${index + 1}`}
          passed={index <= active}
          sx={styles.step}
        />
      ))}
    </Box>
  );
};
